import { action, makeObservable, observable } from "mobx";
import { MrbBaseViewStore } from "mrb/core";
import { find } from "lodash";

class ContentExplorerViewStore extends MrbBaseViewStore {
    @observable selectedTab = { value: 1, title: "Podcast episodes" };

    tabs = [
        { value: 1, title: "Podcast episodes" },
        { value: 2, title: "Album tracks" },
    ];

    constructor(rootStore, { routeStore }) {
        super(rootStore);
        this.routeStore = routeStore;
        makeObservable(this);
    }

    async onInit() {
        var currentRoute = this.rootStore.routerStore.getCurrentRoute();
        if (currentRoute.name === "master.administration.content-explorer.list.podcast-episodes") {
            this.setSelectedTab(1);
        } else if (currentRoute.name === "master.administration.content-explorer.list.album-tracks") {
            this.setSelectedTab(2);
        }
    }

    onViewUpdate(prevProps, newProps) {
        var currentRoute = this.rootStore.routerStore.getCurrentRoute();
        if (
            this.selectedTab.value === 2 &&
            currentRoute.name === "master.administration.content-explorer.list.podcast-episodes"
        ) {
            this.setSelectedTab(1);
        }
    }
    @action.bound
    setSelectedTab(value) {
        this.selectedTab = find(this.tabs, { value: value });
    }
}

export default ContentExplorerViewStore;
